// extracted by mini-css-extract-plugin
export default {"close":"Notice_close__2tGBg","icon":"Notice_icon__6uRiX","icon-variant":"Notice_icon-variant__m1UVf"};